import {
  Eye,
  RefreshCw,
  Heart,
  ListChecks,
  MousePointerClick,
  Trash2,
  Home,
  Briefcase,
  FileText,
  MapPin,
  MessageCircle,
  MessagesSquare,
  ThumbsUp,
  Calculator,
  BarChart3,
} from "lucide-react";

/* Dashboard-specific tour content. The overlay engine (GuidedTour) is
   generic — this is just the data it renders, mirroring the step
   order/copy of the original mobile tour mockup. */
export default function getDashboardTourSteps() {
  return [
    {
      cardSelector: '[data-tour="card-spotlight"]',
      targetSelector: '[data-tour="target-view-details"]',
      icon: <Eye />,
      title: "View details",
      text: "Opens the full breakdown — salary, taxes, cost of living and hospitals for this city.",
    },
    {
      cardSelector: '[data-tour="card-spotlight"]',
      targetSelector: '[data-tour="target-next-city"]',
      icon: <RefreshCw />,
      title: "Next city",
      text: "Cycles the spotlight to the next city matched to your role.",
    },
    {
      cardSelector: '[data-tour="card-spotlight"]',
      targetSelector: '[data-tour="target-save-city"]',
      icon: <Heart />,
      title: "Save the city",
      text: "Tap the heart to save this city to Your Cities for quick comparison later.",
    },
    {
      cardSelector: '[data-tour="card-your-cities"]',
      targetSelector: '[data-tour="target-manage-cities"]',
      icon: <ListChecks />,
      title: "Manage your cities",
      text: "Edit, reorder or remove any city you're tracking — tap Manage to open the full list.",
    },
    {
      cardSelector: '[data-tour="card-your-cities"]',
      targetSelector: '[data-tour="target-city-card"]',
      icon: <MousePointerClick />,
      title: "Open a city",
      text: "Tap any saved city to open its full details — salary, taxes, cost of living and hospitals.",
    },
    {
      cardSelector: '[data-tour="card-your-cities"]',
      targetSelector: '[data-tour="target-city-remove"]',
      icon: <Trash2 />,
      title: "Remove a city",
      text: "Tap the trash icon on a card to remove that city from your saved collection.",
    },
    {
      cardSelector: '[data-tour="card-homeowner"]',
      targetSelector: '[data-tour="target-mortgage-calc"]',
      icon: <Home />,
      title: "Mortgage calculator",
      text: "See what a home here would cost per month and what share of your pay it takes — open the calculator to run the numbers.",
    },
    {
      cardSelector: '[data-tour="card-jobs"]',
      targetSelector: '[data-tour="target-jobs-seeall"]',
      icon: <Briefcase />,
      title: "New RN jobs",
      text: "Fresh roles matched to your role and cities — tap See all for the full list.",
    },
    {
      cardSelector: '[data-tour="card-jobs"]',
      targetSelector: '[data-tour="target-job-card"]',
      icon: <FileText />,
      title: "Open a job",
      text: "Tap any job card to see the full listing — pay, employer, location and how to apply.",
    },
    {
      cardSelector: '[data-tour="card-map"]',
      targetSelector: '[data-tour="target-fullmap"]',
      icon: <MapPin />,
      title: "Hospital map",
      text: "Browse nearby hospitals and their median pay — open the full map to explore.",
    },
    {
      cardSelector: '[data-tour="card-community"]',
      targetSelector: '[data-tour="target-community-feed"]',
      icon: <MessageCircle />,
      title: "Community",
      text: "See what other nurses are discussing — open the feed to join in.",
    },
    {
      cardSelector: '[data-tour="card-community"]',
      targetSelector: '[data-tour="target-community-card"]',
      icon: <MessagesSquare />,
      title: "Open a post",
      text: "Tap any post to open the full discussion and read the replies.",
    },
    {
      cardSelector: '[data-tour="card-community"]',
      targetSelector: '[data-tour="target-community-actions"]',
      icon: <ThumbsUp />,
      title: "React, comment & save",
      text: "Like a post, open its comments to reply, or save it to revisit later.",
    },
    {
      cardSelector: '[data-tour="card-tools"]',
      targetSelector: '[data-tour="target-tools-all"]',
      icon: <Calculator />,
      title: "Featured tools",
      text: "Calculators for pay, taxes and commutes — view all to find the right one.",
    },
    {
      cardSelector: '[data-tour="card-top-cities"]',
      targetSelector: '[data-tour="target-topcities-list"]',
      icon: <BarChart3 />,
      title: "Top cities by leftover",
      text: "Your cities ranked by what's left each month after taxes and housing.",
    },
    {
      cardSelector: '[data-tour="card-top-cities"]',
      targetSelector: '[data-tour="target-topcities-row"]',
      icon: <MousePointerClick />,
      title: "Open a city",
      text: "Tap any ranked city to open its full details — salary, taxes, cost of living and hospitals.",
    },
  ];
}
